module.exports = __webpack_public_path__ + "static/media/1_en.181efea0.png";